import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=3206e8c4&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=3206e8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3206e8c4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/core/Login.vue
// module id = null
// module chunks = 